module.exports = __webpack_public_path__ + "img/usb_c_plugged_into_the_wall-option_2.eb10656a.png";